import React, { FC, useEffect, useState } from 'react'
import _ from 'lodash'
import calcService from "data/calc"
// components
import { Column } from 'primereact/column'
import { DataTable } from 'primereact/datatable'
// lib
import api_match from 'data/interface/api'
import propertyService from 'data/property'
// styles
import { Label_s } from 'styles/app-styles'
import DataTable_s from 'components/table/data-table-styles'
import { MarketLeaseGrid_s } from 'components/property/reports/report-styles'
import marketLeaseService from 'data/market-lease'

interface MarketLeaseGridProps {
  selected: number[],
  setSelected: Function
}

const MarketLeaseTable: FC<MarketLeaseGridProps> = (props) => {
  const [data, setData] = useState<object[]>([])
  const [propertyId, setPropertyId] = useState(propertyService.getStoredPropertyId())

  useEffect(() => {
    const marketLeaseSubscription = marketLeaseService.stream().subscribe(data => {
      api_match(
        data,
        init  => {
          setData(_.sortBy(init.value, ['sortorder']));
          props.setSelected(init.value);
        },
        ok    => {
          setData(_.sortBy(ok.value, ['sortorder']));
          props.setSelected(ok.value);
        },
        err   => {
          setData(err.value)
        },
        fetch => {}
      )
    })
    return function cleanup() {
      marketLeaseSubscription.unsubscribe()
    }
  }, [])

  useEffect(() => {
    setPropertyId(propertyService.getStoredPropertyId());
    if (_.isNil(propertyId)) return
    marketLeaseService.fetchMarketLeases(propertyService.getStoredPropertyId())
  }, [propertyService.getStoredPropertyId()])

  return (
    <MarketLeaseGrid_s>
      <Label_s>Market Lease</Label_s>
      <DataTable_s>
        <DataTable
          value={data}
          paginator={true}
          rows={20}
          rowsPerPageOptions={[10, 20, 50, 100, 500]}
          emptyMessage="No records found"
          selection={props.selected}
          onSelectionChange={(e)=>props.setSelected(e.value)}
        >
          <Column selectionMode="multiple" style={{width: '20px'}} />
          <Column field="code" header="Code" sortable={true} style={{width: '225px'}} />
          <Column field="name" header="Name" sortable={true} style={{width: '225px'}} />
        </DataTable>
      </DataTable_s>
    </MarketLeaseGrid_s>
  )
}

export default MarketLeaseTable
